// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
// import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey            : "AIzaSyAjy5Aebs7us0XgeMheEJAIVgHl1IU_Qf4",
  authDomain        : "athenalogin-80c3e.firebaseapp.com",
  projectId         : "athenalogin-80c3e",
  storageBucket     : "athenalogin-80c3e.appspot.com",
  messagingSenderId : "244787790126",
  appId             : "1:244787790126:web:d3dd262dd164824fe63abf",
  measurementId     : "G-1HKB2QV2QN"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
